import { applicationApi } from 'app/services/api';
import { nanoid } from 'nanoid';

import { catchAsyncActionError } from 'utils/action';
import { getProgressPercentage } from 'utils/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_APPLICATIONS_ACTION_TYPE = createNamedActions('loanApplications', {
  GET_LOAN_APPLICATIONS_BY_PARAMS: 'GET_LOAN_APPLICATIONS_BY_PARAMS',
  GET_LOAN_APPLICATIONS_WITH_LEGACY: 'GET_LOAN_APPLICATIONS_WITH_LEGACY',
  RESET_LOAN_APPLICATIONS: 'RESET_LOAN_APPLICATIONS',
});

export const getLoansApplicationsWithLegacyDataAction = catchAsyncActionError(
  params => async dispatch => {
    const { pageNumber, isFirstFetch } = params;
    const {
      data: { data, totalPages },
    } = await applicationApi.getLoanInfoWithLegacyData(params);

    const formattedData = (data || []).reduce((acc, loan) => {
      const { isLegacy, applicationId, loanPurpose, percentDescription, lockDate } = loan;

      const key = isLegacy ? nanoid() : applicationId;

      acc[key] = {
        ...loan,
        progressPercentage: getProgressPercentage({ loanPurpose, percentDescription, lockDate }),
      };

      return acc;
    }, {});

    return dispatch({
      type: LOAN_APPLICATIONS_ACTION_TYPE.GET_LOAN_APPLICATIONS_WITH_LEGACY,
      payload: formattedData,
      meta: {
        isFirstFetch,
        isLastFetch: totalPages === pageNumber,
        pageNumber,
      },
    });
  },
);

export const resetLoanApplicationsAction = () => ({
  type: LOAN_APPLICATIONS_ACTION_TYPE.RESET_LOAN_APPLICATIONS,
});
